
/**
 * 통화 코드
 */
export type CourseDraftPriceCurrency = typeof CourseDraftPriceCurrency[keyof typeof CourseDraftPriceCurrency];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseDraftPriceCurrency = {
  KRW: 'KRW',
  USD: 'USD',
  EUR: 'EUR',
} as const;
